import { FailureActionPayload } from 'store/errors/types';
import { TenantPortalsResponse } from './types';
import { createAsyncAction } from 'typesafe-actions';

export interface GetTenantPortalsRequest {
  buildingUuid: string;
}

export const getTenantPortals = createAsyncAction(
  'GET_TENANT_PORTALS_REQUEST',
  'GET_TENANT_PORTALS_SUCCESS',
  'GET_TENANT_PORTALS_FAILURE',
)<GetTenantPortalsRequest, TenantPortalsResponse, FailureActionPayload>();
